import * as filterSelectors from '../selectors';
import * as types from '../types';
import {
    setCarriersActive,
    resetCarriers,
} from './carriers';

function setTravelModeValue(travelMode, value, filterId) {
    return (dispatch, getState) => {
        filterId = filterId || filterSelectors.selectFilterId(getState());
        dispatch(_setTravelModeValue(filterId, travelMode, value));

        if (typeof value === 'boolean') {
            const carriersFilterData = filterSelectors.selectCarriersFilterData(
                getState(),
                filterId,
            );
            const mismatchedCarriers = _getAllMismatchedCarriers(
                value,
                travelMode,
                carriersFilterData,
            );

            if (mismatchedCarriers.length > 0) {
                dispatch(setCarriersActive(mismatchedCarriers, travelMode, value));
            }
        }
    };
}

function _getAllMismatchedCarriers(value, travelMode, carrierMap) {
    return Object.entries(carrierMap).reduce((arr, [carrierCode, carrierObj]) => {
        const travelModeObj = carrierObj[travelMode];

        if (travelModeObj && travelModeObj.isActive !== value) {
            return [
                ...arr,
                carrierCode,
            ];
        }

        return arr;
    }, []);
}

function _setTravelModeValue(filterId, travelMode, value) {
    return {
        meta: {
            filterId,
            travelMode,
        },
        payload: value,
        type: types.SET_TRAVEL_MODE_VALUE,
    };
}

function setTravelModeActive(travelMode, isActive, filterId) {
    return (dispatch, getState) => {
        filterId = filterId || filterSelectors.selectFilterId(getState());
        return dispatch(setTravelModeValue(travelMode, isActive, filterId));
    };
}

function setTravelModeOnlyActive(travelModeToSet, filterId) {
    return (dispatch, getState) => {
        filterId = filterId || filterSelectors.selectFilterId(getState());
        const travelModesFilterData = filterSelectors.selectTravelModesFilterData(
            getState(),
            filterId,
        );

        Object.keys(travelModesFilterData).forEach((travelMode) => {
            if (travelMode !== travelModeToSet) {
                return dispatch(setTravelModeValue(travelMode, false, filterId));
            }

            return dispatch(setTravelModeValue(travelMode, true, filterId));
        });
    };
}

function _resetTravelModes(filterId) {
    return {
        meta: filterId,
        type: types.RESET_TRAVEL_MODES,
    };
}

function resetTravelModes(filterId) {
    return (dispatch, getState) => {
        filterId = filterId || filterSelectors.selectFilterId(getState());

        dispatch(_resetTravelModes(filterId));
        dispatch(resetCarriers(filterId));
    };
}

export {
    resetTravelModes,
    setTravelModeActive,
    setTravelModeOnlyActive,
    setTravelModeValue,
};
